import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type TransferReportFilters = {
  vin: string;
  keyword: string;
  title_inn: boolean;
  seller_id: number | null;
  buyer_id: number | null;
  status: string[];
  auction_ids: number[];
  payment_method: string[];
};

type TransferReportSort = {
  sort_column: string | null;
  sort_order: 'asc' | 'desc' | null;
};

type TransferReportState = {
  page: number;
  perPage: number;
  filters: TransferReportFilters;
  sort: TransferReportSort;
};

const initialState: TransferReportState = {
  page: 1,
  perPage: 20,
  filters: {
    vin: '',
    keyword: '',
    title_inn: false,
    seller_id: null,
    buyer_id: null,
    status: [],
    auction_ids: [],
    payment_method: [],
  },
  sort: {
    sort_column: null,
    sort_order: null,
  },
};

const transferReportSlice = createSlice({
  name: 'transferReport',
  initialState,
  reducers: {
    setPage(state, action: PayloadAction<number>) {
      state.page = action.payload;
    },
    setFilters(state, action: PayloadAction<Partial<TransferReportFilters>>) {
      state.filters = { ...state.filters, ...action.payload };
      state.page = 1;
    },
    setSort(state, action: PayloadAction<TransferReportSort>) {
      state.sort = action.payload;
      state.page = 1;
    },
    resetTransferReport() {
      return initialState;
    },
  },
});

export const { setPage, setFilters, setSort, resetTransferReport } = transferReportSlice.actions;
export default transferReportSlice;
